// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lzNtE","smTitle":"styles_smTitle__AC2h7"};